"use strict";

// Single source for the club_engagement_events client contract: the event
// types and sources the app may send to the logClubEngagement callable
// (firebase-functions/clubEngagement.js) and the search-result cap the app's
// services/clubAnalyticsService.js trims to before sending.
// Plain CommonJS with no imports so Metro and Node both load it.
const CLIENT_EVENT_TYPES = Object.freeze(["club_viewed", "club_search_results", "club_share_opened"]);
const CLUB_SOURCES = Object.freeze(["home_list", "search", "category", "share_link", "featured", "event", "profile", "unknown"]);
const MAX_SEARCH_IDS = 20;

module.exports = { CLIENT_EVENT_TYPES, CLUB_SOURCES, MAX_SEARCH_IDS };
